
<div #spacer></div>
<div class="on-top" stickyThing [spacer]="spacer">
    <mat-toolbar class=" mat-elevation-z2 header-toolbar">
            <mat-toolbar-row>
                <button *ngIf="!sideNavVisible" mat-icon-button (click)="expandClick()">
                    <mat-icon>menu_open</mat-icon>
                </button>
                <app-search *ngIf="!(isHandSet$ | async) && userCanSearchCases"></app-search>
                <app-case-actions *ngIf="!(isHandSet$ | async) && showCaseActions" class="ml-3"></app-case-actions>
                <div class="ml-auto">
                <button *appAuthorize="canAddCase" [class.display-none]="isHandSet$ | async" mat-button color="primary" routerLink="/cases/new">
                    <mat-icon class="mr-2">add</mat-icon>
                    Add New Case
                </button>
                <app-user-info
                        [userName]="(userProfile$ | async)?.userName"
                        [lighter]="false"
                        [ngClass]="(isHandSet$ | async)
                      ? 'ml-auto'
                      : 'ml-4' "
                        class="align-self-center">
                </app-user-info>
                <button mat-icon-button [matMenuTriggerFor]="menu" class="ml-2">
                    <mat-icon>menu</mat-icon>
                </button>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    <mat-progress-bar *ngIf="isLoading$ | async" mode="indeterminate" color="accent"></mat-progress-bar>
</div>
<mat-menu #menu="matMenu">
    <div mat-menu-item (click)="onProfileClick()">
        <mat-icon>account_circle</mat-icon>
        <app-user-info [userName]="(userProfile$ | async)?.properName"></app-user-info>
    </div>
    <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
    </button>
</mat-menu>
